/**
 * @desc old name amountExchangerByRate
 * @param bet
 * @param rate
 * @param currentUserId
 * @param precision
 * @param currencyCode
 */
var exchangeAmountByRate = function (_a) {
    var bet = _a.bet, rate = _a.rate, currentUserId = _a.currentUserId, precision = _a.precision, currency = _a.currency;
    var amountPrecision = Math.pow(10, +precision) > 1 ? Math.pow(10, +precision) : 100;
    if (+currentUserId === +(bet === null || bet === void 0 ? void 0 : bet.userId) || !bet.userId || (bet === null || bet === void 0 ? void 0 : bet.currencyCode) === currency) {
        return {
            amount: Math.trunc((bet === null || bet === void 0 ? void 0 : bet.amount) * amountPrecision) / amountPrecision,
            winAmount: Math.trunc((bet === null || bet === void 0 ? void 0 : bet.winAmount) * amountPrecision) / amountPrecision,
        };
    }
    return {
        amount: Math.trunc(((bet === null || bet === void 0 ? void 0 : bet.coinAmount) / +rate) * amountPrecision) / amountPrecision,
        winAmount: Math.trunc(((bet === null || bet === void 0 ? void 0 : bet.winCoinAmount) / +rate) * amountPrecision) / amountPrecision,
    };
};

export { exchangeAmountByRate };
